// extracted by mini-css-extract-plugin
module.exports = {"perspective":"styles_perspective__KV5HH","current":"styles_current__1ON6u","complete":"styles_complete__CHnDa","inProgress":"styles_inProgress__CZggl"};